<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap>
      <h2 class="dark--text text-h5 font-weight-bold">Meals Rating</h2>
    </v-layout>

    <v-layout class="mt-5">
      <v-flex xs8 sm3 md2 lg2>
        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="fromDate" label="From" solo class="ms-sm-1" append-icon="fa-calendar-alt dark--text" v-bind="attrs" v-on="on" @click:clear="fDate = null" dense></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="fDate" @change="selectFromDate"></v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs8 sm2 md2 lg2 class="ml-5">
        <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="toDate" label="To" class="ms-sm-1" solo append-icon="fa-calendar-alt dark--text" v-bind="attrs" v-on="on" @click:clear="tDate = null" dense></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="tDate" @change="selectToDate"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs8 sm2 md2 lg8>
        <v-layout><ExportMealRating :headers="headers" :fDate="fDate" :tDate="tDate"/></v-layout>
      </v-flex>
    </v-layout>
    <!-- {{ mealRatings }} -->

    <v-data-table
      :mobile-breakpoint="0"
      class="mt-6 elevation-1"
      :headers="headers"
      :items="mealRatings"
      :items-per-page="25"
      :options.sync="options"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
      :server-items-length="totalItems"
      :loading="loading"
    >
      <template v-slot:[`item.rating`]="{ item }">
        <v-rating small color="yellow" length="5" size="64" :value="item.rating" :readonly="true"></v-rating>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ new Date(parseInt(item.date)) | moment("MMM DD YYYY") }}
      </template>

      <template v-slot:[`item.customer`]="{ item }">
        <div v-if="item.customer">
          {{ item.customer.user.firstnameEn }}
          {{ item.customer.user.lastnameEn }}
        </div>
      </template>
      <template v-slot:item.customer="{ item }">
        <div v-if="item.customer">
          <div v-if="item.customer">
            <div v-if="item.customer.user">
              <router-link
                v-if="!item.customer.is_deleted"
                :to="{
                  name: 'CustomerDetails',
                  params: { customerId: item.customer._id },
                  query: { customerId: item.customer._id },
                }"
                class="mx-auto"
              >
                <div v-if="item.customer">
                  <div v-if="item.customer.user">
                    {{ item.customer.user.firstnameEn[0].toUpperCase() + item.customer.user.firstnameEn.substring(1) }}
                    {{ item.customer.user.lastnameEn[0].toUpperCase() + item.customer.user.lastnameEn.substring(1) }}
                  </div>
                </div>
                <!-- <div class="mx-1" /> -->
              </router-link>
              <div v-else>
                <!-- <div class="mx-1" /> -->
                <div v-if="item.customer">
                  <div v-if="item.customer.user">
                    {{ item.customer.user.firstnameEn[0].toUpperCase() + item.customer.user.firstnameEn.substring(1) }}
                    {{ item.customer.user.lastnameEn[0].toUpperCase() + item.customer.user.lastnameEn.substring(1) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </v-row> -->
      </template>
      <template v-slot:[`item.phone`]="{ item }">
        <div v-if="item.customer">
          {{ item.customer.user.phone }}
        </div>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ new Date(parseInt(item.createdAt)) | moment("MMM DD YYYY") }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
import { format, parseISO } from "date-fns";
import ExportMealRating from "../components/ExportMealRating.vue";

export default {
  components: {
    ExportMealRating,
  },
  props: {
    subscribedPackages: {
      require: true,
    },
  },

  watch: {
    options: {
      handler() {
        this.getMealRatings();
      },
      deep: true,
    },
  },
  methods: {
    selectFromDate() {
      this.menu1 = false;
      this.getMealRatings();
    },
    selectToDate() {
      this.menu2 = false;
      this.getMealRatings();
    },
    getMealRatings() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../../customer/api/getAllCustomerRating.graphql"),
          variables: {
            customerId: "",
            limit: 0,
            skip: 0,
            sortDesc: false,
            sortBy: "",
            fromDate: this.fDate,
            toDate: this.tDate,
          },
        })
        .refetch({
          customerId: "",
          limit: this.options.itemsPerPage,
          sortDesc: this.options.sortDesc ? this.options.sortDesc[0] : "",
          sortBy: this.options.sortBy ? this.options.sortBy[0] : "",
          skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
          fromDate: this.fDate,
          toDate: this.tDate,
        })
        .then(data => {
          this.loading = false;

          if (data.data.getAllCustomerRating) {
            this.mealRatings = data.data.getAllCustomerRating.customerMealRating;
            this.totalItems = data.data.getAllCustomerRating.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;

          console.log(error);
        });
    },
  },
  computed: {
    fromDate() {
      return this.fDate ? moment(this.fDate).format("DD/MM/YYYY") : "";
    },
    toDate() {
      return this.tDate ? moment(this.tDate).format("DD/MM/YYYY") : "";
    },
  },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.MEALS_RATING_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
    this.getMealRatings();
  },
  data() {
    return {
      fDate: format(
        parseISO(
          moment()
            .subtract(7, "days")
            .toDate()
            .toISOString()
        ),
        "yyyy-MM-dd"
      ),
      tDate: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
      options: {
        itemsPerPage: 25,
        page: 1,
        sortDesc: [],
        sortBy: [],
      },
      mealRatings: [],
      totalItems: 0,
      loading: true,
      menu1: false,
      menu2: false,
      headers: [
        { text: "Date", value: "date", width: 120 },
        { text: "Rating", value: "rating" },
        { text: "Customer", value: "customer", sortable: false },
        { text: "Contact", value: "phone", sortable: false },
        { text: "Meal", value: "meal.nameEn", sortable: false },
        { text: "Comment", value: "comment", sortable: false },
        { text: "Created Date", value: "createdAt", width: 130 },
      ],
    };
  },
};
</script>
